/**
 * @author Mark Cremer <mark@firstcoders.co.uk>
 */
angular.module('satv.media')

.factory('Download', ['config', '$resource', function(config, $resource) {
    "use strict";
    return $resource(config.apiUri + '/media/download', {
        ids: '@ids'
    }, {
        request: {
            method: 'POST',
            transformRequest: function(data) {
              return angular.toJson({
                  format: data.format,
                  filename: data.filename,
                  subjects: data.subjects.map(function(subject) {
                      return subject.id;
                  })
              });
          }
        }
    });
}])

.factory('ZippedDownload', ['config', '$resource', function(config, $resource) {
    "use strict";
    return $resource(config.apiUri + '/media/downloads/:hash/:method', {
        hash: '@hash'
    }, {
        getQueue: {
            method: 'GET',
            isArray: true,
            params: {
                method: 'queue'
            }
        },
        unsubscribe: {
            method: 'POST',
            params: {
                method: 'unsubscribe'
            }
        }
    });
}])

;




// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/services/Download.js